/**
 * Common interface for typing the changes emitted by various controls
 * Can be extended in future to provide a source, which can be the source
 * instance of the event ie. ApxRadioButtonComponent
 */
export interface ApxControlChange<T = string> {
    value: T;
}
